"use strict";
import { Interface } from "@ethersproject/abi";
import IMulticall from "@uniswap/v3-periphery/artifacts/contracts/interfaces/IMulticall.sol/IMulticall.json";
export class Multicall {
  static {
    this.INTERFACE = new Interface(IMulticall.abi);
  }
  /**
   * Cannot be constructed.
   */
  constructor() {
  }
  static encodeMulticall(calldatas) {
    if (!Array.isArray(calldatas)) {
      calldatas = [calldatas];
    }
    return calldatas.length === 1 ? calldatas[0] : Multicall.INTERFACE.encodeFunctionData("multicall", [calldatas]);
  }
  static decodeMulticall(multicall) {
    return Multicall.INTERFACE.decodeFunctionData("multicall", multicall).data;
  }
}
